module.exports = __webpack_public_path__ + "img/index-carousel-0.8b573056.jpg";